import { theme } from 'styled-tools';
import styled from './styled.js';
import as from './as.js';
import Box from './Box.js';
import { b as _extends, a as _objectSpread, d as _inheritsLoose, e as _assertThisInitialized, f as _defineProperty } from './chunk-fb907809.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { a as StepContainer, b as StepNext, c as StepPrevious } from './chunk-2d251948.js';
import { a as callAll } from './chunk-d8771a86.js';
import Step from './Step.js';
import hoistNonReactStatics from 'hoist-non-react-statics';
import Hidden from './Hidden.js';
import 'styled-components';
import '@emotion/is-prop-valid';
import './chunk-a44fd1b3.js';
import './chunk-a7ce379e.js';
import 'constate';
import './chunk-6133b9c9.js';
import 'react-dom';
import './chunk-ac382c96.js';

var Tabs = styled(Box).withConfig({
  displayName: "Tabs",
  componentId: "sc-13wu9lo-0"
})(["", ";"], theme("Tabs"));
Tabs.defaultProps = {
  role: "tablist"
};
var Tabs$1 = as("ul")(Tabs);

var initialState = {
  loop: true,
  current: 0
}; // istanbul ignore next

var TabsContainer = function TabsContainer(props) {
  return React__default.createElement(StepContainer, _extends({}, props, {
    initialState: _objectSpread({}, initialState, props.initialState)
  }));
};

TabsContainer.propTypes = {
  initialState: PropTypes__default.object
};

/* eslint-disable no-param-reassign */
var createElementRef = function createElementRef(scope, property) {
  return function (element) {
    scope[property] = element;

    if (scope.props && scope.props.elementRef) {
      scope.props.elementRef(element);
    }
  };
};

var Component =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Component, _React$Component);

  function Component() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "element", undefined);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "show", function () {
      var _this$props = _this.props,
          show = _this$props.show,
          isCurrent = _this$props.isCurrent,
          tab = _this$props.tab;

      if (!isCurrent(tab)) {
        show(tab);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "keyDown", function (e) {
      var keyMap = {
        ArrowLeft: _this.props.previous,
        ArrowRight: _this.props.next
      };

      if (keyMap[e.key]) {
        e.preventDefault();
        keyMap[e.key]();
      }
    });

    return _this;
  }

  var _proto = Component.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props2 = this.props,
        current = _this$props2.current,
        isCurrent = _this$props2.isCurrent,
        tab = _this$props2.tab;

    if (prevProps.current !== current && isCurrent(tab) && this.element) {
      this.element.focus();
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        isCurrent = _this$props3.isCurrent,
        tab = _this$props3.tab,
        className = _this$props3.className,
        onClick = _this$props3.onClick,
        onFocus = _this$props3.onFocus,
        onKeyDown = _this$props3.onKeyDown;
    var active = isCurrent(tab);
    var activeClassName = active ? "active" : "";
    var finalClassName = [className, activeClassName].filter(Boolean).join(" ");
    return React__default.createElement(Step, _extends({
      id: tab + "Tab",
      step: tab,
      active: active,
      "aria-selected": active,
      "aria-controls": tab + "Panel",
      tabIndex: active ? 0 : -1,
      visible: true
    }, this.props, {
      onClick: callAll(this.show, onClick),
      onFocus: callAll(this.show, onFocus),
      onKeyDown: callAll(this.keyDown, onKeyDown),
      className: finalClassName,
      elementRef: createElementRef(this, "element")
    }));
  };

  return Component;
}(React__default.Component);

var TabsTab = styled(Component).withConfig({
  displayName: "TabsTab",
  componentId: "sc-1eltiq9-0"
})(["", ";"], theme("TabsTab"));
TabsTab.propTypes = {
  tab: PropTypes__default.string.isRequired,
  register: PropTypes__default.func.isRequired,
  update: PropTypes__default.func.isRequired,
  unregister: PropTypes__default.func.isRequired,
  isCurrent: PropTypes__default.func.isRequired,
  show: PropTypes__default.func.isRequired,
  next: PropTypes__default.func.isRequired,
  previous: PropTypes__default.func.isRequired,
  className: PropTypes__default.string,
  disabled: PropTypes__default.bool,
  onClick: PropTypes__default.func,
  onFocus: PropTypes__default.func,
  onKeyDown: PropTypes__default.func
};

var noop = function noop() {};

TabsTab.defaultProps = {
  role: "tab",
  register: noop,
  update: noop,
  unregister: noop,
  isCurrent: noop,
  show: noop,
  next: noop,
  previous: noop
};
var TabsTab$1 = as("li")(TabsTab);

var Component$1 = function Component(props) {
  var isCurrent = props.isCurrent,
      tab = props.tab;
  return React__default.createElement(Hidden, _extends({
    id: tab + "Panel",
    "aria-labelledby": tab + "Tab",
    unmount: true,
    visible: isCurrent && isCurrent(tab)
  }, props));
};

hoistNonReactStatics(Component$1, Hidden);
var TabsPanel = styled(Component$1).withConfig({
  displayName: "TabsPanel",
  componentId: "sc-1iv81zv-0"
})(["", ";"], theme("TabsPanel"));
TabsPanel.propTypes = {
  tab: PropTypes__default.string.isRequired,
  isCurrent: PropTypes__default.func.isRequired
};
TabsPanel.defaultProps = {
  role: "tabpanel"
};
var TabsPanel$1 = as("div")(TabsPanel);

var TabsNext = styled(StepNext).withConfig({
  displayName: "TabsNext",
  componentId: "sc-1tm3dzq-0"
})(["", ";"], theme("TabsNext"));
var TabsNext$1 = as("button")(TabsNext);

var TabsPrevious = styled(StepPrevious).withConfig({
  displayName: "TabsPrevious",
  componentId: "sc-2s0xw8-0"
})(["", ";"], theme("TabsPrevious"));
var TabsPrevious$1 = as("button")(TabsPrevious);

Tabs$1.Container = TabsContainer;
Tabs$1.Tab = TabsTab$1;
Tabs$1.Panel = TabsPanel$1;
Tabs$1.Next = TabsNext$1;
Tabs$1.Previous = TabsPrevious$1;

export default Tabs$1;
